import { describeFields } from '../common/fields';
import { VideoCategorySchema, VideoCategoryTopicSchema } from './schemas';

export const VIDEO_CATEGORY_FIELDS = describeFields(VideoCategorySchema, {
  id: {},
  subject: {},
  code: {},
  label: {},
  shortLabel: {},
  topics: {},
});

export const VIDEO_CATEGORY_TOPIC_FIELDS = describeFields(VideoCategoryTopicSchema, {
  code: {},
  label: {},
  shortLabel: {},
  resources: {},
  videos: {},
});
